<div class="container">
  <video width="100%" src="https://bythewoodside.com/testvideo.mp4"></video>
</div>
